export const qucikLoanPEV1 = [
  "monthlyPropertyGrossRent",
  "annualHOAFee",
  "annualPropertyTaxes",
  "annualInsuranceTotal",
  "verifiedCostsAndImprovements"
];

export const detailedLoanPEV1 = [
  "asIsValue",
  "thirdPartyValuationStatus",
  "thirdPartyValuation",
  "propertyAcquisitionPrice",
  "verifiedCostsAndImprovements",
  "costBasisCalculated",
  "annualPropertyTaxes",
  "annualHazardInsurance",
  "annualFloodInsurance",
  "annualHOAFee",
  "DecliningMarkets",
];
